import React from 'react';

import { useAuthContext } from 'state/auth';
import { t } from 'state/intl/translations';

import { LoggedOutEmptyStateImage } from './images';
import {
  EmptyStateWrapper,
  HeaderText,
  ImageWrapper,
  StyledActionButtonLink,
  SubText,
} from './styled';

const LoggedOutEmptyState = () => {
  const { openSignInModal } = useAuthContext();

  const onPress = () => {
    openSignInModal();
  };

  return (
    <EmptyStateWrapper>
      <ImageWrapper>
        <LoggedOutEmptyStateImage />
      </ImageWrapper>
      <HeaderText>{t('unauthenticatedFavoritesHeader')}</HeaderText>
      <SubText>{t('unauthenticatedFavoritesSubtext')}</SubText>
      <StyledActionButtonLink onPress={onPress}>{t('logIn')}</StyledActionButtonLink>
    </EmptyStateWrapper>
  );
};

export default LoggedOutEmptyState;
